import axios from "../api/axios";
import useAuth from "./useAuth";

function useLogout() {
  const { setAuth } = useAuth();

  const logOut = async () => {
    setAuth();

    try {
      const response = await axios.get("logout", {
        withCredentials: true,
      });
    } catch (err) {
      console.error(err);
    }
  };
  return logOut;
}

export default useLogout;
